import { legacyPlugins } from "/app/node_modules/.pnpm/@unhead+vue@3.4.0_@oxc-project+types@0.149.0_esbuild@0.28.2_lightningcss@1.33.0_oxc-par_4b1c6251f2a774c6cfbb14991d5a76a6/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}